var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M14.909,9.12A8.353,8.353,0,0,0,7.5,4.5,8.354,8.354,0,0,0,.091,9.12a.842.842,0,0,0,0,.76A8.353,8.353,0,0,0,7.5,14.5a8.354,8.354,0,0,0,7.409-4.62A.842.842,0,0,0,14.909,9.12ZM7.5,13.25A3.75,3.75,0,1,1,11.25,9.5,3.75,3.75,0,0,1,7.5,13.25ZM7.5,7a2.482,2.482,0,0,0-.659.1A1.246,1.246,0,0,1,5.1,8.841,2.494,2.494,0,1,0,7.5,7Z",
    transform: "translate(0 -4.5)",
    fill: "#9A9999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeyes);
export default __webpack_public_path__ + "static/media/Icon eyes.3e46bbc9dc23817aef6915c00fe4cff4.svg";
export { ForwardRef as ReactComponent };